module.exports = __webpack_public_path__ + "img/c3.a02e4904.png";